import {components, store} from 'linksoft';

import $ from 'jquery';
import isObject from 'lodash/isObject';
import React from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import {Provider} from 'react-redux';
import debug from 'debug';
const log = debug('linksoft-react');


// initializer
export function initializer() {
    $("[data-component]", this).each((i, element) => {
        const name = $(element).attr('data-component');
        const plainProps = $(element).attr('data-component-props') || $(element).attr('data-component-args') || "{}";
        const props = JSON.parse(plainProps);

        log(`creating component '${name}' with props: ${plainProps}`);
        createComponent(name, element, props);
        log(`component '${name}' created`);
    });
}

// should be called before any ajax request replaces old DOM element(s)
export function finalizer() {
    $("[data-component]", this).each((i, element) => {
        log(`try unmount component from element: %o`, element);
        if(unmountComponentAtNode(element)) {
            log(`component unmounted from element: %o`, element);
        }
        log(`unmount failed. component not found in element: %o`, element);
    });
}

export function createComponent(name, element, props) {
    const Component = components.get()[name];
    if (isObject(Component)) {
        render(
            <Provider store={store.get()}>
                <Component {...props} />
            </Provider>, element);
    }
}


export default {
    initializer,
    finalizer,
    createComponent
}



// WEBPACK FOOTER //
// ./node_modules/linksoft-react/index.js